// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__hhJPC","footer":"ModalFilter_footer__2lYaj"};